import { render, staticRenderFns } from "./enrollmentGuide.vue?vue&type=template&id=2fbd6f5f&scoped=true"
import script from "./enrollmentGuide.vue?vue&type=script&lang=js"
export * from "./enrollmentGuide.vue?vue&type=script&lang=js"
import style0 from "./enrollmentGuide.vue?vue&type=style&index=0&id=2fbd6f5f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd6f5f",
  null
  
)

export default component.exports